import zh from "./locales/zh";
import zhHant from "./locales/zh-hant";
import en from "./locales/en";
import de from "./locales/de";
import pt from "./locales/pt";
import es from "./locales/es";
import fr from "./locales/fr";
import it from "./locales/it";
import hi from "./locales/hi";
import ru from "./locales/ru";
import ko from "./locales/ko";
import ja from "./locales/ja";
import th from "./locales/th";
import tr from "./locales/tr";
import vi from "./locales/vi";
import nl from "./locales/nl";
import id from "./locales/id";
import ar from "./locales/ar";
import pl from "./locales/pl";
import { selectorTranslations } from "./selectorTranslations";
import { selectorBudgetLocales } from "./selectorBudgetLocales";
import { selectorContactTranslations } from "./selectorContactTranslations";
import { emailLeadTranslations } from "./emailLeadTranslations";
import { selectorCountryTranslations } from "./selectorCountryTranslations";

import { footerTranslations } from "./footerTranslations";
import { aboutTranslations } from "./aboutTranslations";
import { customerStoryTranslations } from "./customerStoryTranslations";
import { caseTranslations } from "./caseTranslations";
import { heroBannerTranslations } from "./heroBannerTranslations";
import { uiChromeTranslations } from "./uiChromeTranslations";
import { zhHantPack } from "./zhHantPack";
import { isDomesticLocale } from "./languages";

function mergeLocale(
  base,
  selector,
  budget,
  contact,
  emailLead,
  country = {},
  footer = {},
  about = {},
  customerStory = {},
  cases = {},
  hero = {},
  uiChrome = {}
) {
  return {
    ...base,
    ...selector,
    ...budget,
    ...contact,
    ...emailLead,
    ...country,
    ...footer,
    ...about,
    ...customerStory,
    ...cases,
    ...hero,
    ...uiChrome,
  };
}

const LOCALE_CODES = [
  "zh",
  "zh-hant",
  "en",
  "de",
  "pt",
  "es",
  "fr",
  "it",
  "hi",
  "ru",
  "ko",
  "ja",
  "th",
  "tr",
  "vi",
  "nl",
  "id",
  "ar",
  "pl",
];

const baseLocales = {
  zh,
  "zh-hant": zhHant,
  en,
  de,
  pt,
  es,
  fr,
  it,
  hi,
  ru,
  ko,
  ja,
  th,
  tr,
  vi,
  nl,
  id,
  ar,
  pl,
};

export const translations = Object.fromEntries(
  LOCALE_CODES.map((code) => {
    if (code === "zh-hant") {
      return [
        code,
        mergeLocale(
          baseLocales[code],
          zhHantPack.selector,
          zhHantPack.budget,
          zhHantPack.contact,
          zhHantPack.emailLead,
          {},
          zhHantPack.footer,
          zhHantPack.about,
          zhHantPack.customerStory,
          zhHantPack.cases,
          zhHantPack.hero,
          zhHantPack.uiChrome
        ),
      ];
    }

    return [
      code,
      mergeLocale(
        baseLocales[code],
        selectorTranslations[code] || selectorTranslations.en,
        selectorBudgetLocales[code] || selectorBudgetLocales.en,
        selectorContactTranslations[code] || {},
        emailLeadTranslations[code] || emailLeadTranslations.en,
        isDomesticLocale(code)
          ? {}
          : selectorCountryTranslations[code] || selectorCountryTranslations.en,
        footerTranslations[code] || footerTranslations.en,
        aboutTranslations[code] || aboutTranslations.en,
        customerStoryTranslations[code] || customerStoryTranslations.en,
        caseTranslations[code] || caseTranslations.en,
        heroBannerTranslations[code] || heroBannerTranslations.en,
        uiChromeTranslations[code] || uiChromeTranslations.en
      ),
    ];
  })
);
